import { Create } from "react-admin";
import { AgreementTabbedForm } from "./AgreementTabbedForm";

export const AgreementCreate = (props) => (
  <Create title="Criação de Categoria" {...props}>
    <AgreementTabbedForm {...props} />
  </Create>
);
